import { render, staticRenderFns } from "./TvaSliderContainer.vue?vue&type=template&id=157dfb06&scoped=true&"
import script from "./TvaSliderContainer.vue?vue&type=script&lang=js&"
export * from "./TvaSliderContainer.vue?vue&type=script&lang=js&"
import style0 from "./TvaSliderContainer.vue?vue&type=style&index=0&id=157dfb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157dfb06",
  null
  
)

export default component.exports